/**
 * Flat hex constants mirroring the color tokens in `tailwind.config.js`.
 *
 * `tailwind.config.js` is the source of truth — when a token value changes
 * there, update it here too. This file exists for the places that can't use
 * a Tailwind className directly: components under `src/tailwindcomponents/`
 * that build their base appearance as an inline `style` object (so a
 * caller's `style`/`className` override still wins under the `important:
 * '#root'` config), and other spots that pick a literal color at runtime
 * from a finite set (e.g. a status lookup).
 */
export const palette = {
  primary: '#123A7D',
  secondary: '#F5B53F',
  accent: '#407BAC',
  accentBlue: '#1976d2',
  error: '#B43938',
  warning: '#F5B53F',
  info: '#44A1D0',
  success: '#497523',
  background: '#FAFAFA',
  backgroundPaper: '#FFFFFF',
  content: '#000000',
  muted: '#9D9D9D',
  status: {
    actv: '#9c27b0',
    pause: '#FFFF66',
    inwork: '#506E9F',
    cancel: '#d32f2f',
    complete: '#2e7d32',
    commit: '#E4B7B7',
    unassigned: '#FF0000',
    night: '#FFA500',
  },
  // Day/night shift tint of the Line Planner work package rows and legend chips.
  shift: {
    day: '#FEF3C7',
    night: '#E2E8F0',
  },
} as const;
